import * as PIXI from 'pixi.js'
import TWEEN from '@tweenjs/tween.js'
import Entity from './entity'
import { lerp } from './utils'

const links = [
  [0, -1], [1, -1],
  [1, 0], [1, 1]
]

// Represents an island in the game board
class Node extends Entity {
  selfMatch () {
    const player = this.game.players.playerGet(this.game.ID)
    if (!player) return

    if (this.game.config.clientSync) {
      return this.match
    } else {
      return this.state.playerMatch[this.game.ID]
    }
  }
  selfMatchDelete () {
    delete this.match
    delete this.state.playerMatch[this.game.ID]
  }
  destroy () {
    this._pixi = null
    this._sync.forEach(v => clearTimeout(v))
    this.pixiObj.destroy({ children: true, texture: true, baseTexture: true })
    this.textObj.destroy({ children: true, texture: true, baseTexture: true })
  }
  init (state) {
    this.angle = 0
    this._pixi = {}
    this._sync = new Map()
    this.state = {}

    // Init pixi stuff
    const pixiObj = new PIXI.Graphics()
    // The owner thing

    const nodeObj = new PIXI.Graphics()
    nodeObj.beginFill(this.game.config.nodeColor)
    nodeObj.fillAlpha = this.game.config.nodeAlpha
    nodeObj.drawPoly(0, 0, this.game.config.nodeSize, this.game.config.nodeSize, this.game.config.nodeSides)
    nodeObj.endFill()
    pixiObj.addChild(nodeObj)
    // Before others
    this._pixi.shield = new PIXI.Graphics()
    this._pixi.blast = new PIXI.Graphics()
    this._pixi.owner = new PIXI.Graphics()
    this._pixi.sponsor = new PIXI.Graphics()
    pixiObj.addChild(this._pixi.shield)
    pixiObj.addChild(this._pixi.blast)
    pixiObj.addChild(this._pixi.owner)
    pixiObj.addChild(this._pixi.sponsor)

    const textObj = this.createText(state.word)

    textObj.name = 'text'
    textObj.pivot.x = textObj.width / textObj.scale.x / 2
    textObj.pivot.y = textObj.height / textObj.scale.y / 2
    textObj.scale.set(0.7)

    // textObj.anchor.set(0.5, 0.5)
    // Add lines too
    const posPx = this.game.renderer.gridToPX(state.pos)
    pixiObj.position.set(posPx.x, posPx.y)
    textObj.position.set(posPx.x, posPx.y)
    this.pixiObj = pixiObj
    this.textObj = textObj

    this.set(state)
  }

  createText (text, override) {
    let opt = { ...this.game.config.nodeText }
    Object.assign(opt, override)
    return new PIXI.Text(text, opt)
  }
  createMatchText (text, color, override) {
    let opt = {
      ...this.game.config.nodeText,
      fill: color,
      stroke: color
    }
    opt.strokeThickness -= 1
    Object.assign(opt, override)

    return new PIXI.Text(text, opt)
  }
  // This will remove the color as an explosion on effects layer
  Unclaim () {
    if (this.game.renderer.offScreen(this.pixiObj, 200)) {
      return
    }
    const g = this._pixi.owner // Owner graph
    // Clone graphics
    const clone = g.clone()
    clone.position.set(this.pixiObj.x, this.pixiObj.y)
    // Create new square with those colors
    this.game.renderer.pixi.effects.addChild(clone)
    // this.pixiObj.addChild(clone)
    // Add else where to parent
    const anim = { zoom: 1, alpha: 1 }
    new TWEEN.Tween(anim)
      .to({ zoom: 2, alpha: 0 }, this.game.config.animSpeed)
      .onUpdate(() => {
        if (!clone) return false
        clone.scale.x = anim.zoom
        clone.scale.y = anim.zoom
        clone.alpha = anim.alpha
      }).onComplete(() => {
        clone.destroy({ children: true, texture: true })
      }).start()
  }

  paintShields (state, oldState) {
    if (oldState.shield === state.shield &&
      oldState.blast === state.blast) {
      return
    }
    const g = this._pixi.shield
    g.clear()
    if (state.shield <= 0) {
      return
    }
    // Star on shield, or blast?
    g.beginFill(0x00FF00)
    g.fillAlpha = 0.3
    g.drawStar(0, 0, (state.shield) * 8, 110, 70)
    g.endFill()
    for (let i = 0; i < state.shield; i++) {
      let offset = 115 + (state.blast ? 10 : 0)
      g.lineStyle(8, state.blast ? 0xFF5050 : 0x5090FF)
      g.lineAlpha = 0.3 + i / 4
      g.drawPoly(0, 0, offset + i * 10, offset + i * 10, this.game.config.nodeSides)
      g.endFill()
    }
  }
  paintExplosive (state, oldState) {
    if (state.blast === oldState.blast) {
      return
    }
    const g = this._pixi.blast
    g.clear()
    if (state.blast <= 0) {
      return
    }
    g.lineStyle(8, 0xFF0000)
    g.lineAlpha = 0.8
    g.drawPoly(0, 0, 115, 115, this.game.config.nodeSides)
    g.endFill()

    g.lineStyle(2, 0xFFFF00)
    g.lineAlpha = 0.8
    g.drawPoly(0, 0, 115, 115, this.game.config.nodeSides)
    g.endFill()
  }
  paintSponsor (state, oldState) {
    if (state.sponsored === oldState.sponsored) {
      return
    }
    const g = this._pixi.sponsor
    g.clear()
    if (!state.sponsored) {
      return
    }
    g.lineStyle(16, 0xffff00)
    g.lineAlpha = 0.7
    g.drawPoly(0, 0, 110, 110, this.game.config.nodeSides)
    g.endFill()
  }
  paintOwner (state, oldState) {
    if (state.ownerTeamId === oldState.ownerTeamId) {
      return
    }
    const g = this._pixi.owner

    if (oldState.ownerTeamId) {
      this.Unclaim()
    }
    g.clear()
    if (state.ownerTeamId === '') {
      return
    }

    const ownerTeam = this.game.players.teamGet(state.ownerTeamId)
    if (!ownerTeam) {
      return
    }
    // Get Team?
    // const owner = this.game.players.playerGet(state.ownerId)
    // if (!owner) {
    //  return
    // }
    g.alpha = 0
    g.beginFill(ownerTeam.color)
    g.drawPoly(0, 0, 110, 110, this.game.config.nodeSides)
    g.endFill()
  }

  // Improve performance here
  set (state) {
    const oldState = this.state
    this.state = state

    this.paintShields(state, oldState)
    this.paintExplosive(state, oldState)
    this.paintSponsor(state, oldState)
    this.paintOwner(state, oldState)

    /// ///////////////////////////////////////
    // swap word animation
    /// ///////
    if (oldState.word && state.word !== oldState.word) {
      this.match = undefined // huh
      this.textObj.scale.set(4)
      this.textObj.alpha = 0.3
    }

    const g = this.textObj

    // Remove matches
    g.removeChildren().forEach(r => r.destroy({ children: true, texture: true, baseTexture: true }))
    g.text = state.word

    if (state.sponsored !== oldState.sponsored) {
      g.style.fill = state.sponsored ? 0xFFFFaa : this.game.config.nodeText.fill
      g.dirty = true
    }

    g.pivot.set(
      g.width / g.scale.x / 2,
      g.height / g.scale.y / 2
    )

    // Render matches
    // node matches visualisarion
    let matches = []
    for (let k in state.playerMatch) {
      const player = this.game.players.playerGet(k)
      if (!player || k === this.game.ID) continue
      matches.push({ player: player, match: state.playerMatch[k] })
    }
    matches.sort((a, b) => b.match.length - a.match.length)

    // Our match is inserted in the start of the array after sort
    if (this.selfMatch()) {
      matches.unshift({
        player: this.game.players.playerGet(this.game.ID),
        match: this.selfMatch()
      })
    }

    // Render matches
    for (let i = matches.length - 1; i >= 0; i--) {
      const m = matches[i]
      const matchPIXI = this.createMatchText(m.match, m.player.state.color)
      matchPIXI.x = 0
      matchPIXI.y = i * matchPIXI.height
      g.addChild(matchPIXI)
    }
  }
  update (delta) {
    if (!this.pixiObj) return

    let nodeWiggle = this.game.config.nodeWiggle
    const lerpFactor = this.game.config.lerpFactor * delta
    /// //////////////////////////////////////////
    // This updates text  sizes
    /// /////////
    // WantScale:
    let textScale = (this.state.sponsored) ? 1.3 : 0.8
    let textAlpha = 0.5

    const player = this.game.players.playerGet(this.game.ID)
    if (player) {
      // Old way
      const ppos = player.pos()
      const dx = ppos.x - this.state.pos.x
      const dy = ppos.y - this.state.pos.y

      /* if Math.abs(dx) <=1 && Math.abs(dy) <=1) {
        wantScale = 1.1
        wantAlpha = 1
      } */
      const distP = (dx * dx + dy * dy)

      textScale = Math.max(Math.min(1.1 * 1 / (distP * 0.30), 1.1), 0.5)
      textAlpha = Math.min(1 * 1 / (distP * 0.25), 1)
      nodeWiggle *= Math.min(distP * 0.2, nodeWiggle)

      // NEW selfMatch zoom
      const m = this.selfMatch()
      if (m && m.length > 0) {
        textScale *= 1.5
      }
    }

    const pos = this.game.renderer.gridToPX(this.state.pos)
    this.angle += Math.random() * 0.2 * delta * nodeWiggle
    let nx = pos.x + Math.cos(this.angle) * 5 * nodeWiggle
    let ny = pos.y + Math.sin(this.angle) * 5 * nodeWiggle

    this.pixiObj.position.set(nx, ny)
    /* this.pixiObj.alpha = lerp(
      this.pixiObj.alpha,
      wantAlpha,
      lerpFactor
    ) */

    this.textObj.position.set(nx, ny)
    this.textObj.scale.set(lerp(
      this.textObj.scale.x, textScale,
      lerpFactor
    ))
    this.textObj.alpha = lerp(
      this.textObj.alpha, textAlpha,
      lerpFactor
    )

    if (this._pixi.owner) {
      const g = this._pixi.owner
      g.alpha = lerp(g.alpha, 1, lerpFactor * 0.4)
      g.scale.set(lerp(g.scale.x, 1, lerpFactor * 0.4))
    }

    // Draw links for each node
    // each node draws partially 4 links

    const g = this.game.renderer.pixi.linkMap
    for (let l = 0; l < links.length; l++) {
      const ln = links[l]
      const nodeLink = this.game.nodes.nodeGet(this.state.pos.x + ln[0], this.state.pos.y + ln[1])
      if (!nodeLink) continue
      if (nodeLink.state.ownerTeamId !== this.state.ownerTeamId) {
        continue
      }
      const ownerTeam = this.game.players.teamGet(nodeLink.state.ownerTeamId)
      // const owner = this.game.players.playerGet(nodeLink.state.owner)
      if (!ownerTeam) continue

      // Lines
      g.lineStyle(20, ownerTeam.color)
      g.lineAlpha = 0.5
      g.moveTo(nx, ny)
      g.lineTo(nodeLink.pixiObj.x, nodeLink.pixiObj.y)
    }

    // Our selves
    // Change node color intensity if player is close
    // Player link and word update
    // Try to place this else where?
    if (!player || player.state.curNode === '') { return }

    if (this.state.id !== player.state.curNode) {
      return
    }
    /// ////////////////////////
    // LOCAL PLAYER MATCH links
    for (let y = this.state.pos.y - 1; y <= this.state.pos.y + 1; y++) {
      for (let x = this.state.pos.x - 1; x <= this.state.pos.x + 1; x++) {
        if (x === this.state.pos.x && y === this.state.pos.y) continue // ignore same node
        const nodeLink = this.game.nodes.nodeGet(x, y)
        if (!nodeLink || !nodeLink.pixiObj) continue
        // Calculate the link strength by fetching index

        let curMatch = nodeLink.selfMatch()
        const curIndex = curMatch ? curMatch.length : 0
        const strength = curIndex / nodeLink.state.word.length

        if (strength === 0) { // or no link
          continue
        }

        // Lines
        g.lineStyle(10, player.state.color)
        g.lineAlpha = strength
        g.moveTo(player.pixiObj.x, player.pixiObj.y)
        g.lineTo(nodeLink.pixiObj.x, nodeLink.pixiObj.y)
      }
    }
  }
}

export default Node
